import React from "react";
import DataTable from "react-data-table-component";

function ClientList({ setIsModal, setClientId, setIsDeleteModal, setIsViewModal, data, deletePermission, editPermission, viewPermission, listPermission }) {

    let columnT = ""

    columnT = [
        {
            name: "Name",
            selector: (row) => row.clientName,
            sortable: true,
            cell: (row) => <b>{row.clientName}</b>
        },
        {
            name: "Company",
            selector: (row) => row.companyName,
            sortable: true
        },
        {
            name: "User Name",
            selector: (row) => row.username,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "EMAIL",
            selector: (row) => row.emailId,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "MOBILE",
            selector: (row) => row.phone,
            sortable: true
        },
        {
            name: "PROJECTS",
            selector: (row) => (row.projects && row.projects.length !== 0) ? row.projects.map((pro, i) => pro?.label + (i + 1 === row.projects.length ? "" : ",")) : "-",
            minWidth: "250px",
            wrap: true,
            sortable: true
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" || row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>
        },
        {
            name: "ACTION",
            selector: (row) => { },
            sortable: true,
            minWidth: "150px",
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {(viewPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setClientId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {(editPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setClientId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {(deletePermission === 1) && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setClientId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }

    ]

    return (
        <div className="container-xxl">
            <div className="row clearfix g-3">
                <div className="col-md-12">
                    {listPermission === 1 && (
                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    title={"Client List"}
                                    columns={columnT}
                                    data={data?.client}
                                    defaultSortField="title"
                                    pagination
                                    selectableRows={false}
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )

}

export default ClientList;